import { render, staticRenderFns } from "./ExtractStoreShelve.vue?vue&type=template&id=08bbbe2a&"
import script from "./ExtractStoreShelve.vue?vue&type=script&lang=ts&"
export * from "./ExtractStoreShelve.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports